import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { Suspense } from 'react';
export default function DevtoolsContainer(_ref) {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const EmceeDevtools = /*#__PURE__*/React.lazy(() => import( /* webpackChunkName: "emcee-devtools" */'./Devtools'));
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: "\u2026"
  }, /*#__PURE__*/React.createElement(EmceeDevtools, props));
}